module.exports = __webpack_public_path__ + "static/media/buy-cart_white.e0851ccd.svg";